import React from 'react';
import { loadingCss } from '../styles';

export default function Loading() {
    return (
        <div css={loadingCss}>
            <svg
                className="loading-spinner"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M31.5 16C31.5 12.4813 30.3028 9.06728 28.1051 6.31926C25.9074 3.57123 22.8401 1.65274 19.4075 0.87919C15.9749 0.105638 12.3812 0.523064 9.21726 2.06284C6.05333 3.60262 3.50746 6.1731 1.99821 9.35171C0.488951 12.5303 0.106132 16.1278 0.912686 19.5529C1.71924 22.9779 3.66716 26.0266 6.43621 28.1977C9.20526 30.3688 12.6306 31.5331 16.1492 31.4993C19.6677 31.4654 23.0701 30.2354 25.7968 28.0114"
                    stroke="#635B67"
                    strokeLinecap="round"
                />
            </svg>
        </div>
    );
}
